<template>
    <header class="dark-header">
        <div class="flex flex-vertical-center">
            <!-- <img class="back-icon" src="@images/base/back.png" alt="返回" @click="handleBack" /> -->
            <router-link
                tag="img"
                class="logo"
                :src="logoPng"
                alt="巴蜀中学"
                :to="{ name: 'HomePage' }"
            >
            </router-link>
            <div class="text-second-color">
                欢迎你来到巴蜀网校，<span v-once>{{ date }}</span>
            </div>
        </div>
        <div v-if="userInfo.real_name" class="flex flex-end flex-vertical-center">
            <router-link
                :to="{ name: 'UserCenter' }"
                class="to-usercenter flex flex-vertical-center"
            >
                <span class="user-avatar-container">
                    <img
                        :src="userInfo.avatar ? userInfo.avatar : defaultHeader"
                        alt=""
                        class="user-avatar"
                    />
                </span>
                <span class="username">{{ userInfo.real_name }}</span>
            </router-link>
            <button class="logout" @click="handleLogout">退出</button>
        </div>
        <div v-else>
            <button class="login" :to="{ name: 'Login' }" @click="toLogin">去登录</button>
        </div>
    </header>
</template>

<script>
import moment from '@plugins/_moment';
import { mapGetters } from 'vuex';
import defaultImg from '@images/base/header-exam.png';
import logoPng from '@images/base/logo.png';

export default {
    data() {
        const date = moment();
        return {
            logoPng: logoPng,
            defaultHeader: defaultImg,
            date: date.format('ddd.MM.DD')
        };
    },
    computed: {
        ...mapGetters(['userInfo'])
    },
    methods: {
        handleLogout() {
            this.$store.dispatch('logout', true);
        },
        handleBack() {
            this.$router.back();
        },
        toLogin() {
            const redirectUrl = this.$route.fullPath;
            this.$router.push({ name: 'Login', query: { redirectUrl: redirectUrl } });
        }
    }
};
</script>

<style lang="scss" scoped>
.dark-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 60px;
    background: #1d1d1d;
    padding: 0 30px;
    color: #ffffff;
}
.back-icon {
    width: 14px;
    height: 24px;
    display: block;
    line-height: 0;
    object-fit: contain;
    cursor: pointer;
}
.logo {
    width: 121px;
    height: 40px;
    display: block;
    line-height: 0;
    object-fit: contain;
    // margin-left: 25px;
    margin-right: 17px;
    cursor: pointer;
}
.to-usercenter {
    text-decoration: none;
    .user-avatar-container {
        width: 40px;
        height: 40px;
        border-radius: 50%;
        margin-right: 10px;
        overflow: hidden;
    }
    .user-avatar {
        width: 100%;
        height: 100%;
        border-radius: 50%;
    }
    .username {
        color: #fff;
    }
}
.username:hover {
    color: #7f008f;
}
.logout {
    margin-left: 10px;
    color: #ec4444;
    user-select: none;
    background-color: transparent;
    border: none;
    cursor: pointer;
    &:focus,
    &:active,
    &:visited {
        outline: none;
    }
    &:hover {
        opacity: 0.73;
    }
}

.login {
    margin-left: 10px;
    width: 68px;
    color: #ffffff;
    background: #7f008f;
    user-select: none;
    height: 26px;
    border-radius: 13px;
    border: none;
    cursor: pointer;
    &:focus,
    &:active,
    &:visited {
        outline: none;
    }
    &:hover {
        opacity: 0.73;
    }
}
</style>
